var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBlockCheckinIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.333 5.125c.3 0 .542.243.542.542v8.666c0 .3-.242.542-.542.542h-3.25a.54.54 0 0 1-.541-.542V5.667c0-.3.242-.542.541-.542zm-.541 1.083h-2.167v7.584h2.167zM8.51 9.529 6.93 7.667 7.496 7l2.546 3-2.546 3-.566-.667 1.58-1.862H4.042V9.53z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  d: "m14.938 2.296 1.916 1.607L5.346 17.616 3.431 16.01z"
})));
export { SvgBlockCheckinIcon as ReactComponent };
export default __webpack_public_path__ + "953ffe7812bcbf8eabd08cd2cf4d6f7d.svg";